var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/profile-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-circle_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M15.9998 29.3468C23.3636 29.3468 29.3332 23.3773 29.3332 16.0135C29.3332 8.64971 23.3636 2.68018 15.9998 2.68018C8.63604 2.68018 2.6665 8.64971 2.6665 16.0135C2.6665 23.3773 8.63604 29.3468 15.9998 29.3468Z",
    fill: "#1b1d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 9.25342C13.24 9.25342 11 11.4934 11 14.2534C11 16.9601 13.12 19.1601 15.9333 19.2401C15.9733 19.2401 16.0267 19.2401 16.0533 19.2401C16.08 19.2401 16.12 19.2401 16.1467 19.2401C16.16 19.2401 16.1733 19.2401 16.1733 19.2401C18.8667 19.1468 20.9867 16.9601 21 14.2534C21 11.4934 18.76 9.25342 16 9.25342Z",
    fill: "#1b1d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.04 25.8132C22.6666 27.9998 19.4933 29.3465 16 29.3465C12.5066 29.3465 9.33329 27.9998 6.95996 25.8132C7.27996 24.5998 8.14663 23.4932 9.41329 22.6398C13.0533 20.2132 18.9733 20.2132 22.5866 22.6398C23.8666 23.4932 24.72 24.5998 25.04 25.8132Z",
    fill: "#1b1d52"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircleBlue);
export default __webpack_public_path__ + "static/media/profile-circle-blue.8eb6949a14837b4d58fdcbc4066143e6.svg";
export { ForwardRef as ReactComponent };